import { render } from "./PageBanner.vue?vue&type=template&id=74d4761e&scoped=true"
import script from "./PageBanner.vue?vue&type=script&lang=js"
export * from "./PageBanner.vue?vue&type=script&lang=js"

import "./PageBanner.vue?vue&type=style&index=0&id=74d4761e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\admin\\Desktop\\Расчосков\\rascheskov_katarakta_lending\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d4761e"]])

export default __exports__